import { render, staticRenderFns } from "./Tags.vue?vue&type=template&id=47768851&scoped=true"
import script from "./Tags.vue?vue&type=script&lang=js"
export * from "./Tags.vue?vue&type=script&lang=js"
import style0 from "./Tags.vue?vue&type=style&index=0&id=47768851&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47768851",
  null
  
)

export default component.exports